const PERSIST_STORAGE_KEY = 'persist:saas_front';
// Mirror of SHARED_ACCESS_TOKEN_KEY in services/api/baseApi.ts — inlined to avoid an import
// cycle (baseApi imports this module). Cleared on sign-out so a sibling tab can't adopt a
// now-dead token through the cross-tab refresh path.
const SHARED_ACCESS_TOKEN_KEY = 'relif:lastRefreshedAccessToken';

export function clearPersistedUser(): void {
  localStorage.removeItem(SHARED_ACCESS_TOKEN_KEY);

  const persist = localStorage.getItem(PERSIST_STORAGE_KEY);
  if (!persist) {
    return;
  }

  try {
    const parsed = JSON.parse(persist) as Record<string, unknown>;
    localStorage.setItem(PERSIST_STORAGE_KEY, JSON.stringify({ ...parsed, user: null }));
  } catch {
    // ignore parse errors
  }
}
